import React from 'react'
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom'
import Login from './pages/Login'
import Layout from './components/Layout'
import Dashboard from './pages/Dashboard'
import Rekap from './pages/Rekap'
import Pegawai from './pages/Pegawai'
import Payroll from './pages/Payroll'
import Kasbon from './pages/Kasbon'
import Tabungan from './pages/Tabungan'
import TargetKerja from './pages/TargetKerja'
import JenisPekerjaan from './pages/JenisPekerjaan'
import PaketLangganan from './pages/PaketLangganan'
import PengaturanMikrotik from './pages/PengaturanMikrotik'
import Tagihan from './pages/Tagihan'
import PengaturanTagihanWa from './pages/PengaturanTagihanWa'
import PengaturanMidtrans from './pages/PengaturanMidtrans'
import InvoiceCetak from './pages/InvoiceCetak'
import FotoGallery from './pages/FotoGallery'
import Perangkat from './pages/Perangkat'
import Script from './pages/Script'
import SyncLog from './pages/SyncLog'
import Pengaturan from './pages/Pengaturan'
import BotSettings from './pages/BotSettings'
import TiketGangguan from './pages/TiketGangguan'
import TiketForm from './pages/TiketForm'
import PekerjaanListPublik from './pages/PekerjaanListPublik'
import PekerjaanItemForm from './pages/PekerjaanItemForm'
import ListPekerjaan from './pages/ListPekerjaan'
import PelangganKontak from './pages/PelangganKontak'
import PetaPelanggan from './pages/PetaPelanggan'
import ClientArea from './pages/ClientArea'
import HistoryPembayaran from './pages/HistoryPembayaran'
import BonusPelanggan from './pages/BonusPelanggan'
import TagihanPublik from './pages/TagihanPublik'
import LogChatAI from './pages/LogChatAI'
import ModelOnt from './pages/ModelOnt'
import PerangkatOlt from './pages/PerangkatOlt'
import DriverOlt from './pages/DriverOlt'
import AiAsisten from './pages/AiAsisten'
import AiPlatforms from './pages/AiPlatforms'
import PayrollSlipCetak from './pages/PayrollSlipCetak'
import LogFix from './pages/LogFix'
import Service from './pages/Service'
import PaketVoucher from './pages/PaketVoucher'
import Voucher from './pages/Voucher'
import VoucherCetak from './pages/VoucherCetak'
import { isAdmin, urlLoginDenganNext } from './auth'
import AmbilLokasi from './pages/AmbilLokasi'

// Belum login -> ke /login membawa halaman tujuan (?next=), supaya link yg dibagikan (mis.
// /ambil-lokasi/:username utk teknisi) tetap terbuka setelah login, bukan mental ke dashboard.
function PrivateRoute({ children }) {
  const loc = useLocation()
  return localStorage.getItem('token') ? children : <Navigate to={urlLoginDenganNext(loc.pathname + loc.search)} replace />
}

// Halaman admin-only (Rekap, Perangkat, Script, dst) -- teknisi yg ketik URL-nya langsung di
// address bar dilempar balik ke halaman yg memang boleh mereka lihat, bukan ke /login (identitas
// mereka valid, cuma tidak berhak), sama pola dgn PrivateRoute di atas (redirect, bukan error 403
// mentah). Dibungkus DI DALAM PrivateRoute (lewat Layout's <Outlet>), jadi cuma perlu cek role.
function AdminRoute({ children }) {
  return isAdmin() ? children : <Navigate to="/tiket-gangguan" />
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/tiket/:token" element={<TiketForm />} />
        <Route path="/pekerjaan-list/:token" element={<PekerjaanListPublik />} />
        <Route path="/pekerjaan-list/:token/:id" element={<PekerjaanItemForm />} />
        {/* Halaman tagihan publik (2026-07-22, fase 1 notifikasi isolir) -- TANPA login, dibagikan
            manual (WA pribadi/dicetak) ke pelanggan yg nunggak. Mirror pola /tiket/:token di atas. */}
        <Route path="/tagihan-publik/:token" element={<TagihanPublik />} />
        {/* Standalone, TIDAK dibungkus Layout (tanpa sidebar) -- dibuka di tab baru dari tombol
            Cetak di Payroll.jsx supaya window.print() cuma nyetak slip, tanpa trik CSS "sembunyikan
            elemen lain" yg rapuh lintas browser. Tetap admin-only krn ada data gaji. */}
        <Route path="/payroll/:id/cetak" element={<PrivateRoute><AdminRoute><PayrollSlipCetak /></AdminRoute></PrivateRoute>} />
        {/* Sama pola dgn /payroll/:id/cetak di atas, tapi BUKAN admin-only -- teknisi jg boleh cetak/
            tunjukkan kwitansi ke pelanggan (mereka yg sering catat pembayaran titipan di lapangan). */}
        <Route path="/tagihan/:id/cetak" element={<PrivateRoute><InvoiceCetak /></PrivateRoute>} />
        {/* Cetak voucher (2026-07-25) -- sama pola dgn /payroll/:id/cetak di atas, tapi identifier
            batch lewat query string ?catatan= (bukan :id) krn 1 batch generate = banyak voucher. */}
        <Route path="/voucher/cetak" element={<PrivateRoute><AdminRoute><VoucherCetak /></AdminRoute></PrivateRoute>} />
        <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
          <Route index element={<Navigate to={isAdmin() ? '/dashboard' : '/tiket-gangguan'} />} />
          <Route path="dashboard" element={<AdminRoute><Dashboard /></AdminRoute>} />
          <Route path="rekap" element={<AdminRoute><Rekap /></AdminRoute>} />
          <Route path="pegawai" element={<AdminRoute><Pegawai /></AdminRoute>} />
          <Route path="payroll" element={<AdminRoute><Payroll /></AdminRoute>} />
          <Route path="kasbon" element={<AdminRoute><Kasbon /></AdminRoute>} />
          <Route path="tabungan" element={<AdminRoute><Tabungan /></AdminRoute>} />
          <Route path="target-kerja" element={<AdminRoute><TargetKerja /></AdminRoute>} />
          <Route path="jenis-pekerjaan" element={<AdminRoute><JenisPekerjaan /></AdminRoute>} />
          <Route path="paket-langganan" element={<AdminRoute><PaketLangganan /></AdminRoute>} />
          <Route path="pengaturan-mikrotik" element={<AdminRoute><PengaturanMikrotik /></AdminRoute>} />
          <Route path="paket-voucher" element={<AdminRoute><PaketVoucher /></AdminRoute>} />
          <Route path="voucher" element={<AdminRoute><Voucher /></AdminRoute>} />
          <Route path="tagihan" element={<Tagihan />} />
          <Route path="pengaturan-tagihan-wa" element={<AdminRoute><PengaturanTagihanWa /></AdminRoute>} />
          <Route path="pengaturan-midtrans" element={<AdminRoute><PengaturanMidtrans /></AdminRoute>} />
          <Route path="history-pembayaran" element={<HistoryPembayaran />} />
          <Route path="bonus-pelanggan" element={<AdminRoute><BonusPelanggan /></AdminRoute>} />
          <Route path="foto" element={<AdminRoute><FotoGallery /></AdminRoute>} />
          <Route path="perangkat" element={<AdminRoute><Perangkat /></AdminRoute>} />
          <Route path="script" element={<AdminRoute><Script /></AdminRoute>} />
          <Route path="sync" element={<AdminRoute><SyncLog /></AdminRoute>} />
          <Route path="bot" element={<AdminRoute><BotSettings /></AdminRoute>} />
          <Route path="tiket-gangguan" element={<TiketGangguan />} />
          <Route path="list-pekerjaan" element={<ListPekerjaan />} />
          <Route path="pelanggan-kontak" element={<PelangganKontak />} />
          <Route path="peta-pelanggan" element={<PetaPelanggan />} />
          <Route path="ambil-lokasi/:username" element={<AmbilLokasi />} />
          <Route path="pelanggan-kontak/:username/client-area" element={<ClientArea />} />
          <Route path="log-chat-ai" element={<AdminRoute><LogChatAI /></AdminRoute>} />
          <Route path="model-ont" element={<AdminRoute><ModelOnt /></AdminRoute>} />
          <Route path="perangkat-olt" element={<AdminRoute><PerangkatOlt /></AdminRoute>} />
          <Route path="driver-olt" element={<AdminRoute><DriverOlt /></AdminRoute>} />
          <Route path="ai-asisten" element={<AdminRoute><AiAsisten /></AdminRoute>} />
          <Route path="ai-platforms" element={<AdminRoute><AiPlatforms /></AdminRoute>} />
          <Route path="log-fix" element={<AdminRoute><LogFix /></AdminRoute>} />
          <Route path="service" element={<AdminRoute><Service /></AdminRoute>} />
          <Route path="pengaturan" element={<Pengaturan />} />
        </Route>
      </Routes>
    </BrowserRouter>
  )
}
